export default "__VITE_ASSET__f54e7595__"